import { IFilterValue } from 'components/filters/NewFilterPanel';
import { toast } from 'react-toastify';
import { categoryServices } from 'services/marketpleace';
import { ISelectOption } from 'types/globalTypes';
import { ICategory } from 'types/marketpleace/category.interface';
import i18n from '_i18n/i18n';

export const getCategories = async (academyId: string): Promise<ICategory[]> => {
  try {
    const categories = await categoryServices.get("", academyId);

    return categories;
  } catch (error) {
    console.error(error);
    toast.error(i18n.t('shop.categoriesLoadError'));
    return [];
  }
};

export const getCategoriesSelectOptions = async (academyId: string): Promise<
  ISelectOption<string>[]
> => {
  const categories = await getCategories(academyId);

  const categoriesSelectOptions = categories.map(
    (category: ICategory) =>
      ({
        value: category.CategoryId,
        label: category.Name,
      } as ISelectOption<string>)
  );

  return categoriesSelectOptions;
};

export const getCategoriesTabFilterValues = async (academyId: string): Promise<
  IFilterValue[]
> => {
  const categories = await getCategories(academyId);

  const categoriesSelectOptions = categories.map(
    (category: ICategory) =>
      ({
        backend: category.CategoryId,
        pl: category.Name,
      } as IFilterValue)
  );

  return categoriesSelectOptions;
};
